export default {
  componentName: 'historical-table',
  exampleImgUrl:
    'https://drive.google.com/open?id=1K0B1f-fMiL3pFM3Ugc5dvtoErBgbJsq9',

  nickname: 'historical-table',
  pageList: ['https://www.bassmaster.com/stats/anglers/bobby-lane'],
  renderId: 'react-app--historical-table',
};
